<template>
  <div>
    <span :class="className">
      {{scoreText}}
    </span>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { getStudyAbroadUniversityScoreColor } from "../../../config/mUtils.js";
export default {
  props: {
    data: {},
    columnData: {},
    status: {},
    editLocation: {},
  },
  data() {
    return {
      score: 0,
      scoreText: "",
      className: "",
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      let columnName = this.columnData.Name;
      this.score = this.data[this.columnData.Name];
      if (
        typeof this.score != undefined &&
        this.score != null &&
        this.score != ""
      ) {
        let scoreValue = this.score;
        if (columnName == "LetterGradeScore") {
            this.scoreText = this.score.toString();
        }else if (columnName == "GPAScore") {
            this.scoreText = this.score.toString();
            scoreValue = this.score * 20;
        }else{
            this.scoreText = this.score.toString() + "%";
        }
       
        this.className = getStudyAbroadUniversityScoreColor(scoreValue);
      } else {
        this.className = "cs-color-frenchgrey";
      }
    },
  },
  watch: {
    editLocation: function () {},
    data: function () {
      this.init();
    },
    status: function () {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/studyAbroadUniversityScoreCell.vue